<template>
  <transition name="modal">
    <div
      id="modal"
      class="fixed top-0 right-0 bottom-0 left-0 flex flex-col items-center justify-center overflow-auto"
      :class="zIndexClass"
      v-if="show"
    >
      <div
        class="bg-black-tint fixed top-0 right-0 bottom-0 left-0"
        @click.prevent.stop="close"
      ></div>
      <div
        class="absolute w-full mx-auto h-auto max-h-screen pin-c lg:my-10"
        :class="containerClasses"
      >
        <button
          @click.prevent.stop="close"
          class="modal-close-button text-white absolute z-10 top-0 right-0 h-12.5 w-12.5 lg:h-15 lg:w-15"
          v-if="showCloseButton"
        ></button>
        <div class="relative lg:mb-10" :class="wrapperClasses">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    zIndexClass: {
      type: String,
      default: 'z-50',
    },
    wrapperClasses: {
      type: String,
      default: 'lg:my-10 lg:rounded-lg',
    },
    containerClasses: {
      type: String,
      default: 'max-w-screen-xl',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      scrollY: null,
    };
  },

  methods: {
    open: function() {
      this.scrollY = window.scrollY;
      document.body.classList.add('fixed', 'left-0', 'right-0');
      document.documentElement.style.overflow = 'scroll';
      document.documentElement.style['-webkit-overflow-scrolling'] = 'touch';
      document.body.style.top = `-${this.scrollY}px`;
    },

    close: function() {
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, this.scrollY);
      document.documentElement.style.scrollBehavior = 'smooth';
      document.documentElement.style.overflow = '';
      document.documentElement.style['-webkit-overflow-scrolling'] = '';
      document.body.classList.remove('fixed', 'left-0', 'right-0');

      this.$emit('close');
    },
  },

  mounted() {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.key == 'Escape') {
        this.close();
      }
    });
  },

  destroyed() {
    this.close();
  },

  watch: {
    show: {
      immediate: true,
      handler: function(new_val, old_val) {
        if (new_val) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
};
</script>
